import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Select,
  Box,
  Typography,
  Tooltip,
  IconButton,
  Link,
} from '@mui/material';
import { useEffect, useState } from 'react';
import BackButton from 'src/components/BackButton';
import SuccessButton from 'src/components/SuccessButton';
import { formatDate } from 'src/utils/formatTime';
import Iconify from 'src/components/Iconify';
import { pagesText } from 'src/constants/pagesText';
import { EDIT_STATUS_NOTE_INFO_LINK } from './constants';
import { packagedAppsStatusList } from './constants';

const EditDataModal = ({
                         open,
                         onClose,
                         currentStatus,
                         currentNote,
                         currentDate,
                         onSave,
                         loading,
                         disableStatusSelect = false,
                       }) => {
  const [newStatus, setNewStatus] = useState(currentStatus || '');
  const [note, setNote] = useState(currentNote || '');

  useEffect(() => {
    if (open) {
      setNewStatus(currentStatus || '');
      setNote(currentNote || '');
    }
  }, [currentStatus, currentNote, open]);

  const handleSave = () => {
    onSave(newStatus, note.trim());
  };

  const hasStatusChanged = newStatus !== (currentStatus || '');
  const hasNoteChanged = note.trim() !== (currentNote || '').trim();
  const saveDisabled = loading || !(hasStatusChanged || hasNoteChanged);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {pagesText.packagedApps.editDataModal.title}
        <Tooltip
          arrow
          placement="right"
          componentsProps={{ tooltip: { sx: { maxWidth: 500, pointerEvents: 'auto' } } }}
          title={
            <Typography variant="body2" mb={1}>
              {pagesText.packagedApps.editDataModal.tooltipText}
              <Link
                href={EDIT_STATUS_NOTE_INFO_LINK}
                target="_blank"
                rel="noopener"
                underline="hover">
                More Info
              </Link>
            </Typography>
          }>
          <IconButton size="small">
            <Iconify icon="material-symbols:info-outline" width={24} height={24} />
          </IconButton>
        </Tooltip>
      </DialogTitle>

      <DialogContent>
        <Box mt={2}>
          <Typography mb={1}>Last Updated</Typography>
          <Typography variant="body2">{currentDate ? formatDate(currentDate) : '-'}</Typography>
        </Box>

        <Box mt={2}>
          <Typography mb={1}>Status</Typography>
          <Select
            disabled={disableStatusSelect}
            size="small"
            fullWidth
            value={newStatus}
            onChange={e => setNewStatus(e.target.value)}>
            {packagedAppsStatusList.map(option => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </Box>

        <Box mt={2}>
          <Typography mb={1}>Note</Typography>
          <TextField
            size="small"
            fullWidth
            value={note}
            onChange={e => setNote(e.target.value)}
            placeholder="Enter note"
            multiline
            minRows={2}
            maxRows={4}
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <BackButton disabled={loading} onClick={onClose}>
          Close
        </BackButton>
        <SuccessButton disabled={saveDisabled} onClick={handleSave} loading={loading}>
          Save
        </SuccessButton>
      </DialogActions>
    </Dialog>
  );
};

export default EditDataModal;
